import styled from "styled-components";

const MyAccountAreaSectionWrapper = styled.div`
  background: ${props => props.theme.backgrounds.boxBG};
  border-radius: 1rem;
  display: flex;
  justify-content: center;
  position: relative;
  flex-direction: inherit;
  padding: 1.2rem 1rem;
  margin-bottom: 2rem;
`;

export { MyAccountAreaSectionWrapper };
